import React from "react";
import { Button, Spin } from "antd";
import appreciate from "../../assets/images/stars_connected_image.png";
// import appreciate from "../../assets/images/icons/appreciate.png";
import { useAppSelector } from "../../hooks/reduxHooks";
import { getFirstName } from "../../utils/helper.util";
import AppreciateYouShareOptions from "./ShareButtons";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";

interface AppreciateYouComponentInterface {
  data: any;
}

const AppreciateYouComponent: React.FC<AppreciateYouComponentInterface> = (
  props
) => {
  const { data } = props;
  const state = useAppSelector((state) => state);
  const { name, loadingProfile } = state?.profile;
  const firstName = getFirstName(name);
  const navigate = useNavigate();

  return (
    <>
      <div className="appreciateYouPage">
        <h1>You are precious{name ? `, ${firstName}` : ""}</h1>
        <img src={appreciate} className="appreciate" alt="appreciate_img" />
        <h3>You light up the universe making every connection special!</h3>
        <div className="appreciateYouPage__message">
          <div className="appreciateYouPage__message__text">
            {loadingProfile ? (
              <Spin className="appreciateYouPage__message__spinner" />
            ) : (
              <>
                <h3>A Thank You Note for {firstName}</h3>
                <p>{data}</p>
                <span className="footnote">— Entire Team @missingskincare</span>
              </>
            )}
          </div>
        </div>
      </div>
      {/* <AppreciateYouShareOptions /> */}
      <div className="footer-cta">
        <Button
          className="btn-primary cta-btn"
          onClick={() => {
            navigate("/store/subscription");
            ReactGA.event({
              category: "Store",
              action: `Freedom Pay click`,
              label: "Clicked on Go to Freedom Pay in Appreciate you",
              nonInteraction: true, // optional, true/false
              transport: "xhr",
            });
          }}
        >
          Go to Subscription & Billing
        </Button>
      </div>
    </>
  );
};

export default AppreciateYouComponent;
